import React from 'react'

export const StateOfCSSIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="711"
        height="236"
        fill="none"
        viewBox="0 0 711 236"
    >
        <path d="M247 111.878C250.007 53.437 297.011 6.433 355.452 3.425v108.453zM367.367 3.275H475.82c-3.007 58.44-50.011 105.445-108.452 108.452zM247 232.4c3.007-58.442 50.011-105.446 108.452-108.453V232.4zm120.367-108.605H475.82c-3.007 58.442-50.011 105.446-108.452 108.453zm114.719-11.917C485.093 53.437 532.097 6.433 590.538 3.425l.001 108.453zM602.457 3.275h108.452c-3.007 58.44-50.011 105.445-108.452 108.452zM482.086 232.4c3.007-58.442 50.011-105.446 108.452-108.453l.001 108.453zm120.371-108.605h108.452c-3.007 58.442-50.011 105.446-108.452 108.453zM0 111.878C3.007 53.437 50.011 6.433 108.452 3.425v108.453zM228.975 3.272c-3.007 58.442-50.011 105.446-108.452 108.453V3.272zM108.452 232.248C50.012 229.241 3.007 182.237 0 123.795h108.452zm12.071-108.301c58.442 3.007 105.446 50.011 108.453 108.453H120.523z"></path>
    </svg>
)
